import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/query-client";

export const MFA_STATUS_KEY = ["/api/mfa/status"];

export type MfaState = "ok" | "enrollment_required" | "verification_required";

export interface MfaStatus {
  state: MfaState;
  required: boolean;
  enrolled: boolean;
  isOwnerOrAdmin: boolean;
  requireForAdjusters: boolean;
  recoveryCodesRemaining: number | null;
}

export async function fetchMfaStatus(): Promise<MfaStatus> {
  const res = await apiRequest("GET", "/api/mfa/status");
  return res.json();
}

/**
 * What this session still has to do for multi-factor authentication. The server enforces it on every route; this
 * only tells the browser which screen to show. A failed lookup is not treated as "blocked": the server answers 403
 * with an MFA code on any route that needs it.
 */
export function useMfaStatus(enabled: boolean) {
  return useQuery<MfaStatus>({
    queryKey: MFA_STATUS_KEY,
    queryFn: fetchMfaStatus,
    enabled,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
